module.exports = __webpack_public_path__ + "static/img/9.a635df2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/9.png
// module id = xxKr
// module chunks = 0